<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <combo-field
          slot="su_type"
          :label="customLabel.su_type || '类型'"
          v-model="form.main.su_type"
          url="/api/document/suppliestype/getCombo"
        />
        <project-field
          slot="pj_dename"
          @select="onSelectProject"
          :label="customLabel.pj_dename || '项目名称'"
          v-model="form.main.pj_dename"
        />
        <div class="weui-cell" v-if="form.main.pj_emname" slot="pj_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_emname }}
          </div>
        </div>
        <div
          class="weui-cell"
          v-if="form.main.pj_product_type"
          slot="pj_product_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pj_product_type || "产品类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.pj_product_type }}
          </div>
        </div>
        <div class="weui-cell" slot="su_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.su_remark || "申请原因"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.su_remark"
              placeholder="请输入申请原因"
            />
          </div>
        </div>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>用品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <div class="weui-cell" slot="sd_name">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_name || "用品名称"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.sd_name"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sd_spec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_spec || "用品规格"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.sd_spec"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sd_amount">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_amount || "金额"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.sd_amount"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="sd_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.sd_remark || "备注"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.sd_remark"
                placeholder="请填写"
              />
            </div>
          </div>
        </custom-layout>
        <div class="weui-cells" style="margin-top: 0">
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
      <file-field v-model="form.main.su_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboField from "@/components/field/ComboField.vue";
import FileField from "@/components/field/FileField.vue";
import ProjectField from "@/components/field/ProjectField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    ComboField,
    ProjectField,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/supplies",
      codeField: "su_code",
      statusField: "su_statuscode",
      caller: "Supplies",
      xtype: "oa-supplies-formpanel",
      form: {
        main: {},
        items: [
          {
            sd_detno: 1,
            sd_name: "",
            sd_spec: "",
            sd_amount: 0,
            sd_remark: "",
          },
        ],
      },
    };
  },
  methods: {
    onSelectProject(selection) {
      var me = this,
        main = me.form.main;
      main.su_sourceid = selection.pj_id;
      main.su_sourcecode = selection.pj_code;
      main.pj_dename = selection.pj_dename;
      main.pj_emid = selection.pj_emid;
      main.pj_emname = selection.pj_emname;
      main.pj_product_type = selection.pj_product_type;
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.su_remark) {
        me.$weui.topTips("请填写申请原因", 2000);
      } else {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        sd_detno: items.length + 1,
        sd_name: "",
        sd_spec: "",
        sd_amount: 0,
        sd_remark: "",
      });
    },
  },
};
</script>